import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery, getUrl} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {
    ProductCreateDTO,
    ProductDTO,
    ProductEditDTO,
    ProductsDTO,
    ProductsGetParams
} from "../../types/products/ProductDTO";
import {DeleteParams} from "../../types/utils/Constants";

export const productsApi = createApi({
    reducerPath: "product",
    baseQuery: apiQuery,
    tagTypes: ["products", "product"],
    endpoints: builder => ({
        getProducts: builder.query<Response<ProductsDTO[]>, Partial<ProductsGetParams>>({
            query: (params) => getUrl('/products', [
                {name: "category_id", value: params.category_id},
                {name: "account_id", value: params.account_id}]),
            providesTags: ['products']
        }),
        getProductById: builder.query<Response<ProductDTO>, Partial<number | undefined | null>>({
            query: (id) => `/products/${id}`,
            providesTags: ["product"]
        }),
        createProduct: builder.mutation <Response<void>, Partial<ProductCreateDTO>>({
            query: (body) => ({
                url: "/products",
                method: "POST",
                body
            }),
            invalidatesTags: ['products']
        }),
        editProduct: builder.mutation <Response<void>, Partial<ProductEditDTO>>({
            query: (body) => ({
                url: `/products/${body.id}`,
                method: "PATCH",
                body
            }),
            invalidatesTags: ['products', 'product']
        }),
        deleteProduct: builder.mutation <void, Partial<DeleteParams>>({
            query: (params) => ({
                url: getUrl(`/products/${params.id}`, [{name: "account_id", value: params.accountId}]),
                method: "DELETE"
            }),
            invalidatesTags: ['products']
        })
    })
})

export const {
    useGetProductsQuery,
    useGetProductByIdQuery,
    useEditProductMutation,
    useCreateProductMutation,
    useDeleteProductMutation
} = productsApi
